import styles from './DailyActivitiesCard.module.css';

const DailyActivitiesCard = ({ icon, label, count }) => {
  return (
    <div className={styles.card}>
      <div className={styles.left}>
        <img src={icon} alt={label} className={styles.icon} />
        <span className={styles.label}>{label}</span>
      </div>
      <div className={styles.count}>{count}</div>
    </div>
  );
};

export default DailyActivitiesCard;
